import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Navigation from './components/navigation';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Profile from "./components/ProfilePage/Profile";
import { setAdminStatus } from "./redux/slices/isAdminSlice";
import UnderDevelopment from "./components/UnderDevelopment";
import LoaderInside from './components/LoaderInside';
import config from "./config";
import { setUserData, fetchCurrentUser } from "./redux/slices/userSlice";
import RatingTable from "./components/RaitingPage/RatingTable";
import OnboardingFlow from "./components/onboarding/OnboardingFlow";
import Gifts from "./components/GiftsPage/GiftComponent";
import FAQPage from "./components/FAQPage/FAQPage";
import FAQContent from "./components/FAQPage/FAQContent";
import FAQCreate from "./components/FAQPage/FAQCreate";
import LessonsPage from './components/LessonsPage/LessonsPage';
import LessonContent from './components/LessonsPage/LessonContent';
import AdminPage from './components/AdminPage/AdminPage';
import ErrorScreen from './components/ErrorScreen';
import LoginPage from './components/Auth/LoginPage';
import RegisterPage from './components/Auth/RegisterPage';
import axios from "axios";
import './scss/all.scss'

const App = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isNewUser, setIsNewUser] = useState(false);
  const dispatch = useDispatch();
  const wrapWithAuthLayout = (content) => (
    <div className="main">
      <div className="main-content auth-page">
        {content}
      </div>
    </div>
  );

  useEffect(() => {
    const authenticate = async () => {
      try {
        // Проверяем, доступен ли объект Telegram Web App
        const isTelegram = window.Telegram && window.Telegram.WebApp;
        const initData = isTelegram ? window.Telegram.WebApp.initData : null;
        const authToken = localStorage.getItem('authToken');

        if (isTelegram && initData) {
          // Telegram аутентификация
          window.Telegram.WebApp.ready();
          try {
            const response = await axios.post(`${config.API_BASE_URL}/auth`, { initData });
            const fetchedUser = response.data.user;
            setUser(fetchedUser);
            setIsNewUser(fetchedUser.isNew);
            dispatch(setUserData({
              userId: fetchedUser._id,
              telegramId: fetchedUser.id,
              username: fetchedUser.username,
              role: fetchedUser.role,
              accountType: fetchedUser.accountType,
              isNew: fetchedUser.isNew,
              isAccepted: fetchedUser.isAccepted
            }));
            dispatch(setAdminStatus(fetchedUser.role === 'superuser'));
          } catch (error) {
            console.error('Telegram auth error:', error);
            setError("Ошибка авторизации через Telegram. Пожалуйста, обновите страницу.");
          }
        } else if (authToken) {
          // Веб-аутентификация через JWT токен
          try {
            // Получаем пользователя через thunk и используем его результат напрямую
            const fetchedUser = await dispatch(fetchCurrentUser()).unwrap();
            if (fetchedUser && fetchedUser._id) {
              setUser(fetchedUser);
              setIsNewUser(fetchedUser.isNew || false);
              dispatch(setAdminStatus(fetchedUser.role === 'superuser'));
            } else {
              // Токен невалидный, очищаем его
              localStorage.removeItem('authToken');
              setUser(null);
            }
          } catch (error) {
            console.error('Web auth error:', error);
            localStorage.removeItem('authToken');
            setUser(null);
          }
        } else {
          // Нет ни Telegram, ни токена - веб-версия без авторизации
          setUser(null);
        }
      } catch (error) {
        console.error('Auth error:', error);
        setError("Ошибка авторизации. Проверьте настройки.");
      } finally {
        setIsLoading(false);
      }
    };

    authenticate();
  }, [dispatch]);


  if (isLoading) {
    return (
      <div className="main-load">
        <LoaderInside />
      </div>
    );
  }

  // Если есть ошибка и мы в Telegram, показываем ErrorScreen
  if (error && window.Telegram?.WebApp) {
    return (
      <div className="error-message">
        <ErrorScreen />
      </div>
    );
  }

  return (
    <Router>
      <div>
        <Routes>
          {/* Страницы аутентификации (доступны без авторизации) */}
          <Route
            path="/login"
            element={
              user
                ? <Navigate to="/" />
                : wrapWithAuthLayout(<LoginPage />)
            }
          />
          <Route
            path="/register"
            element={
              user
                ? <Navigate to="/" />
                : wrapWithAuthLayout(<RegisterPage />)
            }
          />

          {/* Если пользователь новый, показываем страницу предрегистрации */}
          {user && isNewUser ? (
            <Route
              path="*"
              element={
                <div className="faq-main">
                  <div className="main-content">
                    <OnboardingFlow />
                  </div>
                </div>
              }
            />
          ) : (
            <>
              {/* Главная страница - теперь с уроками */}
              <Route
                path="/"
                element={user ? (
                  <div className="main-lessons">
                    <div className="main-content">
                      <LessonsPage />
                    </div>
                  </div>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              {/* Профиль */}
              <Route
                path="/profile"
                element={user ? (
                  <div className="main">
                    <div className="main-content">
                      <Profile />
                    </div>
                  </div>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              {/* Победы */}
              <Route
                path="/gifts"
                element={user ? (
                  <div className="main">
                    <div className="main-content">
                      <Gifts />
                    </div>
                  </div>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              {/* FAQ Главная страница */}
              <Route
                path="/faq"
                element={user ? (
                  <div className="faq-main">
                    <div className="main-content">
                      <FAQPage />
                    </div>
                  </div>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              {/* FAQ детальная страница */}
              <Route
                path="/faq/:category"
                element={user ? (
                  <div className="faq-main">
                    <div className="main-content">
                      <FAQContent />
                    </div>
                  </div>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              {/* FAQ создание новой записи */}
              <Route
                path="/faq/:category/create"
                element={user ? (
                  <div className="faq-main">
                    <div className="main-content">
                      <FAQCreate />
                    </div>
                  </div>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              {/* Рейтинг */}
              <Route
                path="/rating"
                element={user ? (
                  <div className="main">
                    <div className="main-content">
                      <RatingTable />
                    </div>
                  </div>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              {/* Веб-админка */}
              <Route
                path="/admin"
                element={user ? (
                  <div className="main">
                    <div className="main-content">
                      <AdminPage />
                    </div>
                  </div>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              {/* Страница содержимого урока */}
              <Route
                path="/lessons/:moduleName/:lessonId"
                element={user ? (
                  <div className="main">
                    <div className="main-content">
                      <LessonContent />
                    </div>
                  </div>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              {/* Служебные маршруты */}
              <Route
                path="/soon"
                element={user ? <div className="main-load"><UnderDevelopment /></div> : <Navigate to="/login" />}
              />
            </>
          )}
        </Routes>
        {/* Показываем навигацию только если пользователь авторизован и не проходит онбординг */}
        {user && !isNewUser && <Navigation />}
      </div>
    </Router>
  );
};

export default App;
